import { cn } from "@cliently/ui";

/**
 * Symbole de marque Cliently : un monogramme sobre plutôt qu'une icône
 * générique de dashboard. Réutilisé dans la sidebar (et potentiellement
 * d'autres écrans applicatifs) pour porter l'identité du produit.
 */
export const BrandMark = ({ className }: Readonly<{ className?: string }>) => (
  <span
    aria-hidden
    className={cn(
      "inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg",
      "bg-primary text-primary-foreground font-serif text-[16px] font-semibold",
      "shadow-sm",
      className,
    )}
  >
    C
  </span>
);
